<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="批次" name='batch_sn'>
      <a-input v-model:value="search.batch_sn" style="width:200px" placeholder="请输入批次号进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="流水号" name='code'>
      <a-input v-model:value="search.code" style="width:200px" placeholder="请输入流水号进行搜索"></a-input>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='batch_sn' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' v-if='!checkout' :ghost="!record.select">{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { activitysSelectBatchList } from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 5,
  batch_sn: "",
  code: "",
  activity_id:"",
  source_type:1
};
export default {
  name: "selectCodeBatchAct",
  components: {},
  props: {
    selectList: {
      type: Array,
    },
    checkout: {
      type: Boolean,
    },
    activity_id:{
      type:Number
    }
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 0,
      selectList: []
    });
    let columns = [
      {
        title: "批次",
        dataIndex: "batch_sn",
        key: "batch_sn",
      },
      {
        title: "码类型",
        dataIndex: "scenerio_type_text",
        key: "scenerio_type_text",
      },
      {
        title: "流水号区间",
        dataIndex: "small_serial",
        key: "small_serial",
        customRender: ({ text, record }) => {
          return record.code_start + "-" + record.code_end;
        },
      },
      {
        title: "数量",
        dataIndex: "code_counts",
        key: "code_counts",
      },

      {
        title: "添加时间",
        dataIndex: "created_time",
        key: "created_time",
      },

      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const batchData = ref({});
    //单选
    const select = (e) => {
      data.value.map((item) => (item.select = false));
      if (e != 0) {
        e.select = !e.select;
      }
      emit("select", e);
    };
    //多选
    const checkBnt = (e) => {
      if (!e.select) {
        state.selectList.push(e);
      } else {
        var index = 0;
        state.selectList.forEach((v, k) => {
          if (v.batch_sn == e.batch_sn) {
            index = k;
          }
        });
        state.selectList.splice(index, 1);
      }
      e.select = !e.select;
    };
    //多选确认
    const confirm = () => {
      emit("select", state.selectList);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await activitysSelectBatchList({ ...values,activity_id:props.activity_id }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
          if (state.selectList && state.selectList.length > 0) {
            data.value.forEach((i) => {
              if (
                state.selectList.find((v) => {
                  return i.batch_sn == v.batch_sn;
                })
              ) {
                i.select = true;
              }
            });
          }
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
      if (props.selectList) {
        state.selectList = JSON.parse(JSON.stringify(props.selectList));
      }
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      select,
      checkBnt,
      confirm
    };
  },
};
</script>